export const STORAGE_CENTRE_LABELS = {
  ZC: 'Christchurch',
  ZD: 'Dunedin',
  ZH: 'Bremen-Blumenthal',
  ZJ: 'Biella',
  ZK: 'Grisignano',
  ZO: 'Keelung',
  ZP: 'Shanghai',
  ZQ: 'Qingdao',
  ZR: 'Zhangjiagang',
  ZT: 'Timaru',
  ZV: 'Invercargill',
  ZX: 'Napier',
  ZY: 'Ashburton',
  ZB: 'Blenheim',
  ZL: 'Mosgiel',
}

/**
 * Retrieves the label for a given storage centre code.
 *
 * @param code - The code of the storage centre to look up.
 * @returns The label corresponding to the provided code from the `STORAGE_CENTRES` object.
 *
 * If the code is not found, the function returns the code itself.
 */
export const getStorageCentreLabel = (code: string) => {
  return STORAGE_CENTRE_LABELS[code as keyof typeof STORAGE_CENTRE_LABELS] || code
}
